<div fxLayout="column" fxLayoutGap="16px">
  <div>
    <span class="title">Edit Document</span>
    <app-document-form
      #form
      [tagMatches]="tagMatches$ | async"
      [disabled]="isLoading$ | async"
      [ngModel]="document"
      (ngModelChange)="onDocumentChange($event)"
      (tagChange)="onTagChange($event)"></app-document-form>
    <mat-divider [inset]="true"></mat-divider>
  </div>

  <div fxLayout fxLayoutAlign="flex-end">
    <button
      mat-raised-button
      color="primary"
      [disabled]="!form.valid"
      [appLoading]="isUpdating$ | async"
      (click)="updateDocument()">
      Save Changes
    </button>
  </div>
</div>
